import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-hero-image-full-no-carousel.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var BannerHeroImageFullNoCarousel = /** @class */ (function (_super) {
    tslib_1.__extends(BannerHeroImageFullNoCarousel, _super);
    function BannerHeroImageFullNoCarousel(element) {
        return _super.call(this, element) || this;
    }
    BannerHeroImageFullNoCarousel.prototype.init = function () {
        var _this = this;
        this.swiperContainer = this.element.querySelector('.banner-hero-image-full-no-carousel__carousel--container');
        this.carouselContainer = this.element.querySelector('.banner-hero-image-full-no-carousel__carousel--swiper');
        this.items = Array.from(this.element.querySelectorAll('.swiper-slide'));
        if (this.items.length === 3) {
            this.swiperContainer.classList.add('three-items');
        }
        else if (this.items.length === 2) {
            this.swiperContainer.classList.add('two-items');
        }
        else if (this.items.length === 1) {
            this.swiperContainer.classList.add('one-item');
        }
        this.createCarouselPageLoad();
        window.addEventListener('resize', function () {
            _this.createCarouselResize();
        });
    };
    BannerHeroImageFullNoCarousel.prototype.bindEvents = function () {
    };
    BannerHeroImageFullNoCarousel.prototype.createCarouselPageLoad = function () {
        if (this.swiperContainer.classList.contains('three-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1.1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1201: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1025: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    581: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('two-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1.1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1201: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1025: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    581: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('one-item')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1.1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1201: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1025: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    581: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 10,
                    }
                },
                freeMode: false,
                navigation: {
                    nextEl: '.banner-hero-image-full-no-carousel__carousel--container__rightarrow',
                    prevEl: '.banner-hero-image-full-no-carousel__carousel--container__leftarrow',
                }
            });
        }
        // let generateBreakpoints: any = this.generateBreakpoints();
        // this.carousel = new Swiper(this.carouselContainer, {
        // 	slidesPerView: generateBreakpoints.slidesPerView,
        // 	centeredSlides: false,
        // 	spaceBetween: 30,
        // 	initialSlide: 0,
        // 	breakpoints: generateBreakpoints.breakpoints,
        // 	freeMode: false
        // });
    };
    BannerHeroImageFullNoCarousel.prototype.createCarouselResize = function () {
        this.carousel.destroy();
        if (this.swiperContainer.classList.contains('three-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1.1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1201: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1025: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    581: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('two-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1.1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1201: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1025: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    581: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('one-item')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1.1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1201: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1025: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    581: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 10,
                    }
                },
                freeMode: false,
                navigation: {
                    nextEl: '.banner-hero-image-full-no-carousel__carousel--container__rightarrow',
                    prevEl: '.banner-hero-image-full-no-carousel__carousel--container__leftarrow',
                }
            });
        }
        // let generateBreakpoints: any = this.generateBreakpoints();
        // this.carousel = new Swiper(this.carouselContainer, {
        // 	slidesPerView: generateBreakpoints.slidesPerView,
        // 	centeredSlides: false,
        // 	spaceBetween: 30,
        // 	initialSlide: 0,
        // 	breakpoints: generateBreakpoints.breakpoints,
        // 	freeMode: false
        // });
    };
    BannerHeroImageFullNoCarousel.prototype.generateBreakpoints = function () {
        var slidesPerView = 0;
        var breakpoints = {};
        // if there are only 3 slides captured
        if (this.swiperContainer.classList.contains('three-items')) {
            slidesPerView = 3;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
            // if there are only 2 slides captured
        }
        else if (this.swiperContainer.classList.contains('two-items')) {
            slidesPerView = 2;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
            // if there are only 1 slide captured
        }
        else if (this.swiperContainer.classList.contains('one-item')) {
            slidesPerView = 1;
            // if there are is more than 3 items
        }
        else {
            slidesPerView = 3;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
        }
        return {
            slidesPerView: slidesPerView,
            breakpoints: breakpoints
        };
    };
    return BannerHeroImageFullNoCarousel;
}(Base));
export { BannerHeroImageFullNoCarousel };



//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-image-full-no-carousel/banner-hero-image-full-no-carousel.component.ts
// module id = 687
// module chunks = 0